const textDecoder = new TextDecoder('utf-8');
const codecsLocalStorageKey = 'codecs.riverside.fm';
export function generateFileName(email, slug, username, accountId, studioId, takeId, version = '3') {
	// const now = new Date().getTime();
	const timestamp = getFormattedTime();
	let localStorageName = username;
	if (!localStorageName) {
		localStorageName = localStorage.getItem('name');
	}
	if (localStorageName) {
		localStorageName = localStorageName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
	} else {
		localStorageName = 'guest';
	}
	const archiveId = localStorageName + '-' + Math.random().toString(36).substr(2, 9);
	let path;
	if (version == '4' && accountId && studioId && takeId) {
		path = `accounts/${accountId}/studios/${studioId}/takes/${takeId}/${archiveId}/`;
	} else {
		path = `users/${email}/recordings/${slug}/${archiveId}/`;
	}
	console.log(path, version, 'path');
	const filename = localStorageName + '-' + timestamp + '.webm'; //unique filename

	return [path + filename, localStorageName, archiveId, timestamp];
}

function generateTimestamp() {
	// rahov29766-laklica-com_1_01-30-2021_212328.mp4
}

function getFormattedTime() {
	var today = new Date();
	var y = today.getFullYear();
	// JavaScript months are 0-based.
	var m = today.getMonth() + 1;
	var d = today.getDate();
	var h = today.getHours();
	var mi = today.getMinutes();
	var s = today.getSeconds();
	return y + '-' + m + '-' + d + '__' + h + '-' + mi + '-' + s;
}
function blobToArrayBufferFileReader(blob) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.addEventListener('loadend', (e) => {
			const res = reader.result;
			return resolve(res);
		});

		reader.addEventListener('error', reject);
		reader.readAsArrayBuffer(blob);
	});
}

export async function blobToArrayBuffer(blob) {
	if (!blob instanceof Blob) {
		return blob;
	}
	var blobData;
	try {
		blobData = await new Response(blob).arrayBuffer();
	} catch (error) {
		console.log('failed local arraybuffer', error);
		try {
			blobData = await blob.arrayBuffer();
		} catch (error) {
			try {
				blobData = await blobToArrayBufferFileReader(blob);
			} catch (error) {
				/*this.log(
          { error, name: error?.target?.error?.name, message: error?.target?.error?.message },
          'blobToArrayBufferError',
          'error'
        );*/
				// throw error;
				console.error(error);
				throw error;
			}
		}
	}
	return blobData;
}

export function getArrayBuffer(size) {
	const buffer = new ArrayBuffer(size);
	const view = new Uint8Array(buffer);
	const len = view.length;
	for (let i = 0; i < len; i++) {
		view[i] = Math.random() * (126 - 33) + 33;
	}
	return buffer;
}

/* Generate a random string of size X */
export function getStr(size) {
	const buffer = getArrayBuffer(size);
	return textDecoder.decode(buffer);
}

export async function getBlobDuration(blob) {
	const tempVideoEl = document.createElement('video');

	const durationP = new Promise((resolve) =>
		tempVideoEl.addEventListener('loadedmetadata', () => {
			// Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=642012
			if (tempVideoEl.duration === Infinity) {
				tempVideoEl.currentTime = Number.MAX_SAFE_INTEGER;
				tempVideoEl.ontimeupdate = () => {
					tempVideoEl.ontimeupdate = null;
					resolve(tempVideoEl.duration);
					tempVideoEl.currentTime = 0;
					tempVideoEl.remove();
				};
			}
			// Normal behavior
			else resolve(tempVideoEl.duration);
			tempVideoEl.remove();
		})
	);

	tempVideoEl.src = typeof blob === 'string' || blob instanceof String ? blob : window.URL.createObjectURL(blob);

	return durationP;
}

export function getBitrateAndResolution(stream, mimeType = '', maximumBitrate = 10000000) {
	let bitrates = [8000000, 5500000, 4000000, 2000000];
	if (mimeType.indexOf('vp8') != -1) {
		bitrates = [12000000, 8000000, 6000000, 4000000];
	}
	const videoTracks = stream.getVideoTracks();

	if (videoTracks.length == 0) return [2500000, '480x360', '30'];
	const settings = videoTracks[0].getSettings();
	//console.log('settings', settings);
	const height = settings.height;
	const resolution = settings.width + 'x' + settings.height;
	const framerate = settings.framerate;
	if (height >= 2160) {
		return [Math.min(bitrates[0], maximumBitrate * 1000000), resolution, framerate];
	} else if (height >= 1080) {
		return [Math.min(bitrates[1], maximumBitrate * 1000000), resolution, framerate];
	} else if (height >= 720) {
		return [Math.min(bitrates[2], maximumBitrate * 1000000), resolution, framerate];
	} else {
		return [Math.min(bitrates[3], maximumBitrate * 1000000), resolution, framerate];
	}
}

export function getMimeType(stream, vEncoder = null) {
	//return 'video/webm;codecs=vp8,opus'
	//return 'video/webm;codecs=avc1.640034,pcm';
	let codecsPerformance = getCodecPerformance();
	let audioC = window.MediaRecorder.isTypeSupported('audio/webm;codecs=pcm') ? 'pcm' : 'opus';
	let videoC = 'avc1.640034';
	if (vEncoder) {
		videoC = vEncoder;
	}
	//videoC = 'vp8';
	let bitrateAdaptation = 0;
	let performance = 10;
	let mode = 0;
	if (videoC.includes('tester')) {
		if (videoC.includes('testerB')) {
			mode = 1;
		}
		let bitrateIdx = videoC.indexOf('+');
		if (bitrateIdx != -1) {
			bitrateAdaptation = parseInt(videoC.substring(bitrateIdx + 1));
			videoC = videoC.substring(videoC.indexOf('@') + 1, bitrateIdx);
		} else {
			videoC = videoC.substring(videoC.indexOf('@') + 1);
		}

		let codecBaseName = videoC;
		if (codecBaseName.indexOf('.') != -1) {
			codecBaseName = codecBaseName.substring(0, codecBaseName.indexOf('.'));
		}
		performance = codecsPerformance[codecBaseName];

		if (performance < -20) {
			videoC = 'vp8';
			bitrateAdaptation = 0;
		} else if (mode == 0) {
			if (performance != 10) {
				switch (codecBaseName) {
					case 'avc1':
						if (codecsPerformance['vp8'] != null && codecsPerformance['vp8'] > performance) {
							videoC = 'vp8';
						}
						break;
					case 'vp8':
						if (codecsPerformance['avc1'] != null && codecsPerformance['avc1'] > performance) {
							videoC = 'avc1.640034';
						}
						break;
				}
			}
		}
	}

	if (!MediaRecorder.isTypeSupported(`video/webm;codecs=${videoC},${audioC}`)) {
		videoC = 'h264';
		if (!MediaRecorder.isTypeSupported(`video/webm;codecs=${videoC},${audioC}`)) {
			videoC = 'vp8';
		}
	}

	if (performance >= 8) {
		bitrateAdaptation = 0;
	}
	//console.warn(vp9, 'video c');
	if (stream.getVideoTracks().length) {
		return { mimeType: `video/webm;codecs=${videoC},${audioC}`, bitrateAdaptation };
	}

	return { mimeType: `audio/webm;codecs=${audioC}`, bitrateAdaptation };
	/*
	let mimeType = 'audio/webm;codecs=opus';
	try {
		window.MediaRecorder.isTypeSupported(mimeType);
	} catch (error) {
		if (stream.getVideoTracks().length) {
			return 'video/webm;codecs=h264,opus';
		} else {
			return 'audio/webm;codecs=opus';
		}
	}
	if (stream.getVideoTracks().length) {
		mimeType = 'video/webm;codecs=h264,opus';
		if (!window.MediaRecorder.isTypeSupported(mimeType)) {
			//TODO:Emit error
			//this.showPopup('RiversideFM is optimized for Chrome, please use Chrome');
			mimeType = 'video/webm;codecs=vp8,opus';
			//???? Why not windows.MediaRecorder
			if (!MediaRecorder.isTypeSupported(mimeType)) {
				mimeType = 'video/webm';
			}
		}
	} else {
		if (!MediaRecorder.isTypeSupported(mimeType)) {
			mimeType = 'audio/webm';
		}
	}
	return mimeType;
	*/
}

export function getDeviceLabels(stream) {
	const audioTracks = stream.getAudioTracks();
	const videoTracks = stream.getVideoTracks();
	let audioDeviceLabel, videoDeviceLabel;
	if (audioTracks.length == 0) {
		audioDeviceLabel = 'no-audio';
	} else {
		//if (this.audioTrackLabel) audioDeviceLabel = this.audioTrackLabel;
		//else
		audioDeviceLabel = audioTracks[0].label;
	}
	if (videoTracks.length == 0) {
		videoDeviceLabel = 'no-cam';
	} else {
		videoDeviceLabel = videoTracks[0].label;
	}
	return [audioDeviceLabel, videoDeviceLabel];
}

export function getResolutionString(width) {
	if (width > 1920) {
		return 'UHD';
	} else if (width > 1280) {
		return 'FHD';
	} else {
		return 'XGA';
	}
}

export function getCodecPerformance() {
	let storedCodecs = JSON.parse(localStorage.getItem(codecsLocalStorageKey)) || {};
	return storedCodecs;
}

export function setCodecScore(codecName, score) {
	let storedCodecs = JSON.parse(localStorage.getItem(codecsLocalStorageKey)) || {};
	storedCodecs[codecName] = score;
	localStorage.setItem(codecsLocalStorageKey, JSON.stringify(storedCodecs));
}

export function getVideoCardInfo() {
	const canvas = document.createElement('canvas');
	const gl = canvas.getContext('webgl');
	if (!gl) {
		return {
			error: 'no webgl',
		};
	}
	const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
	canvas.remove();
	return debugInfo
		? {
				vendor: gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL),
				renderer: gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL),
		  }
		: {
				error: 'no WEBGL_debug_renderer_info',
		  };
}
